import React, { useEffect, useState } from "react";
import {getAllMembers,getMemberCount} from '../../../features/member/helper/api';
import "../style.scss";
import { isAuthenticated } from "../../../auth";
import _ from "lodash";
// import config from "../../../config";
import client from "../../../clients";

const MemberFilter = ({getSelectedMember}, props) => {

  const dummySelectedMember = {
    _id: "dfksjd4342",
    name: "Member Name",
    phone: "+91 8837373737"
  }

  const [selectedMember, setSelectedMember] = useState();
  const [memberList, setMemberList] = useState([]);
  const [gym,setGym] = useState('');
  const [memberSearch,setMemberSearch]=useState('');
  const [startMemberLoader,setStartMemberLoader] = useState(false);
  const {user,token} = isAuthenticated();
  var [pageNo,setPageNo] = useState({
    member:1,
  });

  var pageSize = {
    member:20,
  };

  var [pageCount,setPageCount] = useState({
    member:1
  })

  var [total,setTotal] = useState({
    member:0
  })

  const handleMemberSearch = event =>{
    setMemberSearch(event.target.value);
  }

  const GetMemberParams=()=>{
    const params={
      pageNo:pageNo.member,
      pageSize:pageSize.member
    };
    if(gym) params.branchIDs=gym._id;
    return params;
  }

  const GetMembers = async (isReload) =>{
    try{
      const params = GetMemberParams();

      const response = await getAllMembers(user._id,token,params);

      if(response.error){
        //error
      }else{
        if(isReload) setMemberList(response);
        else setMemberList([...memberList,...response]);
      }
    }catch(error){

    }
    setStartMemberLoader(false)
  }

  const GetMemberCount = async (isReload) =>{
    try{
      delete params.pageNo
      delete params.pageSize
      const params = GetMemberParams();

      const response = await getMemberCount(user._id,token,params);

      if(response.error){
        //error
      }else{
        pageNo.member = 1;
        setPageNo({
          ...pageNo
        })
        pageCount.member = Math.ceil(response.COUNT / pageSize.member);
        setPageCount({
          ...pageCount
        })
        total.member = response.COUNT;
        setTotal({
          ...total
        })
      }
    }catch(error){

    }
  }


  const handleSelectMember = (selectedMember) => {
    setSelectedMember(selectedMember);
    getSelectedMember(selectedMember);
  }

  const handleScrollMember = async event => {
    const { offsetHeight, scrollTop, scrollHeight } = event.target;
    if (offsetHeight + scrollTop === scrollHeight && pageNo.member < pageCount.member && !startMemberLoader) {
      pageNo.member = pageNo.member + 1;
      setPageNo(pageNo)
      setStartMemberLoader(true)
      await GetMembers();
    }
  }

  useEffect(()=>{
    if(props.gym) setGym(props.gym)
  },[props]);

  useEffect(async ()=>{
    try{
      setStartMemberLoader(true);
      await GetMemberCount()
      await GetMembers(true)
    }catch(error){
      setStartMemberLoader(false);
    }
  },[memberSearch]);


  return(
    <div className="w-full">
      {
        (selectedMember && selectedMember._id) ? (
          <div className="w-full">
            {
              props.header && (
                <p className="fs-16 font-weight-700 color-black m-b-12">Selected Member</p>
              )
            }
            <div className="w-full d-flex space-between">
              <div className="d-flex m-b-12" style={{width:"80%"}}>
              {
                (selectedMember.user && selectedMember.user.length>0) 
                && ((selectedMember.user[0].profileID) ? (
                  <div className="member-filter-img d-flex flex-item">
                    <img className="flex-item" src={`${client.config.API_URL}/image/file/${selectedMember.user[0].profileID}/auto/auto/70`} />
                  </div>
                ) : (
                  <div className='member-filter-img d-flex flex-item' style={{
                    backgroundColor:'#5d883c'
                  }}>
                    <p className='flex-item' style={{
                      color: '#ffffff', margin: '0 auto', fontSize: 14
                    }}>
                      {`${selectedMember.user[0].name}`.trim()[0]}
                    </p>
                  </div>
                ))
              }
                {/* <div className="member-filter-img d-flex flex-item">
                  <img className="flex-item" src={"https://picsum.photos/200/300"} />
                </div> */}
                <div className="m-l-8 flex-item" style={{width:"76%"}}>
                  <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{selectedMember.userInfo.name}</p>
                  <p className="fs-12 font-weight-400 color-grey-03 m-t-4" style={{lineHeight:"12px"}}>{selectedMember.userInfo.phone}</p>
                </div>
              </div>
              <div className="d-flex m-t-4" style={{alignSelf:"flex-start"}}>
                <div className="table-action-button d-flex" style={{backgroundColor: "#ffffff", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)"}}>
                  <svg className="flex-item margin-auto" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5828 4.41713C17.1024 3.93682 16.4508 3.66699 15.7715 3.66699C15.0921 3.66699 14.4406 3.93682 13.9602 4.41713L4.90097 13.4775C4.63678 13.7415 4.4545 14.0762 4.37606 14.4413L3.67774 17.6996C3.65932 17.7852 3.66265 17.874 3.6874 17.958C3.71216 18.0419 3.75756 18.1183 3.81945 18.1802C3.88135 18.2421 3.95777 18.2875 4.04173 18.3123C4.12569 18.337 4.21452 18.3403 4.3001 18.3219L7.55855 17.6237C7.92372 17.5452 8.25845 17.3629 8.52247 17.0988L17.5828 8.03896C18.0629 7.5586 18.3327 6.90722 18.3327 6.22804C18.3327 5.54886 18.0629 4.89749 17.5828 4.41713ZM14.7015 5.15784C14.9879 4.88696 15.3688 4.7385 15.763 4.74403C16.1572 4.74955 16.5337 4.90862 16.8124 5.18742C17.0912 5.46622 17.2502 5.84274 17.2556 6.23693C17.261 6.63112 17.1125 7.01188 16.8415 7.29825L16.37 7.7697L14.2295 5.62982L14.7015 5.15784ZM13.4882 6.37053L15.6287 8.51094L7.78225 16.3586C7.66083 16.4799 7.50692 16.5636 7.33905 16.5995L4.87111 17.1286L5.40022 14.6613C5.43615 14.4935 5.51983 14.3396 5.6412 14.2182L13.4882 6.37053Z" fill="var(--darkBlue)"/>
                  </svg>
                </div>
                {
                  props.delete && (
                    <div className="table-action-button d-flex m-l-16" style={{backgroundColor: "#ffffff", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)"}}>
                      <svg className="flex-item margin-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.616 20.0005C7.168 20.0005 6.78667 19.8431 6.472 19.5285C6.15733 19.2138 6 18.8328 6 18.3855V6.00047H5V5.00047H9V4.23047H15V5.00047H19V6.00047H18V18.3855C18 18.8455 17.846 19.2298 17.538 19.5385C17.23 19.8471 16.8453 20.0011 16.384 20.0005H7.616ZM17 6.00047H7V18.3855C7 18.5648 7.05767 18.7121 7.173 18.8275C7.28833 18.9428 7.436 19.0005 7.616 19.0005H16.385C16.5383 19.0005 16.6793 18.9365 16.808 18.8085C16.9367 18.6805 17.0007 18.5391 17 18.3845V6.00047ZM9.808 17.0005H10.808V8.00047H9.808V17.0005ZM13.192 17.0005H14.192V8.00047H13.192V17.0005Z" fill="#E33A34"/>
                      </svg>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full">
            <div className="search-container d-flex space-between" style={{width:"100%",background:"#f5f5f5"}}>
              <div className="d-flex w-full">
                <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input onInput={_.debounce(handleMemberSearch,700)} type="text" placeholder={`Search Gym by  “Name, location“`} className="flex-item search-input" style={{width:"85%"}} />
              </div>
            </div>
            <p className="fs-16 font-weight-700 color-black m-t-20 m-b-16">Select Member</p>
            <div onScroll={handleScrollMember} style={{overflowY:'auto', maxHeight:'300px'}}>
              {
                memberList.map(data => {
                  return(
                    <div onClick={()=>handleSelectMember(data)} className="d-flex m-b-12">
                      {
                        (data.user && data.user.length>0) 
                        && ((data.user[0].profileID) ? (
                          <div className="member-filter-img d-flex">
                            <img className="flex-item" src={`${client.config.API_URL}/image/file/${data.user[0].profileID}/auto/auto/70`} />
                          </div>
                        ) : (
                          <div className='member-filter-img d-flex' style={{
                            backgroundColor: '#5d883c'
                          }}>
                            <p className='flex-item' style={{
                              color: '#ffffff', margin: '0 auto', fontSize: 14
                            }}>
                              {`${data.user[0].name}`.trim()[0]}
                            </p>
                          </div>
                        ))
                      }
                      {/* <div className="member-filter-img d-flex">
                        <img className="flex-item" src={"https://picsum.photos/200/300"} />
                      </div> */}
                      <div className="flex-item m-l-8">
                        <p className="font-weight-600" style={{lineHeight:"16px"}}>{data.userInfo && data.userInfo.name}</p>
                        <p className="fs-12 font-weight-400 color-grey-03 m-t-4" style={{lineHeight:"12px"}}>{data.userInfo && data.userInfo.phone}</p>
                      </div>
                    </div>
                  )
                })
              }
              {startMemberLoader && <div className="loader-5 center"><span></span></div>}
            </div>
          </div>
        )
      }
    </div>
  )
}

export default MemberFilter;